<template>
  <div style="width:100%">
    <div>
      <mt-header title="系统信息">
        <!-- <router-link to="/My" slot="left">
          <mt-button icon="back">返回</mt-button>
        </router-link> -->
      </mt-header>
    </div>
    <div>
      <p class="content">
        <el-row>
          <el-col :span="6"> 系统：</el-col>
          <el-col :span="18"> {{ SystemName }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 单位：</el-col>
          <el-col :span="18"> {{ MaintenanceUnitName }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 版本：</el-col>
          <el-col :span="18"> 1.0.0 </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> UserApi：</el-col>
          <el-col :span="18"> 2.0.0 </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> PstApi：</el-col>
          <el-col :span="18"> 1.0.0 </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 设计：</el-col>
          <el-col :span="18"> 山行客 </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" style=""> 联系：</el-col>
          <el-col :span="18"> 13874595820 </el-col>
        </el-row>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "About",
  methods: {
    formReturn() {
      // this.$router.push({ path: "/" });
      history.back(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .miniTool {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
div {
  .title {
    font-size: 20px;
  }
  .content {
    color: gray;
    margin: 10px 5px;
  }
  .el-row {
    line-height: 30px;
    .el-col-6 {
      text-align: right;
    }
  }
}
</style>